import { render, staticRenderFns } from "./PhieuSuaChua.vue?vue&type=template&id=21b1f4c1&scoped=true&"
import script from "./PhieuSuaChua.vue?vue&type=script&lang=js&"
export * from "./PhieuSuaChua.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1f4c1",
  null
  
)

export default component.exports